// eslint-disable-next-line
import { GetSensors, GetSensorStatus, GetRssiRanges } from '@/api/api';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,
  state: { /* = data */
    sensors: [],
    sensorStatus: [],
    sensorStatusFilter: null,
    rssiRanges: [],
    loading: {
      sensors: false,
      sensorStatus: false,
      global: false,
    },
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
    sensorsFiltered(state) {
      let sensorFiltered = state.sensors;
      
      if (state.sensorStatusFilter) {
        if (state.sensorStatusFilter == 'INTERMITENT') {
          sensorFiltered = state.sensors.filter((sensor) => {
            if(sensor.status_id == "DEPLOYED" && sensor.last_reading){
              let now = new Date();
              const dateObj = new Date(sensor.last_reading);

              let hours = Math.abs(now - dateObj) / 36e5;

              return hours > 24 ? true : false;
            }
            return false;
          });
        }else{
          sensorFiltered = state.sensors.filter((sensor) => sensor.status_id === state.sensorStatusFilter);
        }
      }
        

      if(state.sensorStatusFilter == "DEPLOY_PENDING" || state.sensorStatusFilter == "DEPLOYING"){
        const value = 'serial_number';
        sensorFiltered = sensorFiltered.sort(function (a, b) {
          if (a[value] < b[value]) return -1;
          if (a[value] > b[value]) return 1;
          return 0;
        });
      }else{
        sensorFiltered = sensorFiltered.sort((a, b) => {
          const sortBy = 'location_code';
          if (!a['hole_id'] && !b['hole_id']) {
              // no hole, order by location_code
              if (!a[sortBy] && !b[sortBy]) {
                return 0;
              }
              else if (a[sortBy] && !b[sortBy]) {
                return -1;
              } 
              else if (!a[sortBy] && b[sortBy]) {
                return 1;
              } 
              else {
                return String(a[sortBy]).localeCompare(String(b[sortBy]));
              }
          }
          else if (a['hole_id'] && !b['hole_id']) {
              return -1;
          } 
          else if (!a['hole_id'] && b['hole_id']) {
              return 1;
          } 
          else {
              const holeA = parseInt(a['hole']['hole_number']);
              const holeB = parseInt(b['hole']['hole_number']);
  
              if (holeA > holeB){
                return 1;
                  
              } else if (holeB > holeA) {
                return -1;
              } else {
                return String(a[sortBy]).localeCompare(String(b[sortBy]));
              }
          }
          return -1;
        });
      }

      return sensorFiltered;

    },
  },


  actions: { /* = Methods */

    async loadSensors({ commit, state, getters }, hideLoading) {
      if (Mixin.methods.G_isEmptyArr(getters.sensorsFiltered) && !hideLoading) {
        commit('setLoading', { ...state.loading, sensors: true });
      }

      // Before load sensors we must load RSSI Ranges
      if (Mixin.methods.G_isEmptyArr(state.rssiRanges)) {
        await GetRssiRanges().then((rssiRanges) => {
          commit('setRssiRanges', rssiRanges);
        });
      }

      await GetSensors().then((response) => {
        commit('setSensors', response.sensors);
        commit('setLoading', { ...state.loading, sensors: false });
      }).catch(() => {
        commit('setLoading', { ...state.loading, sensors: false });
      });
    },

    async loadSensorStatus({ commit, state }) {
      if (Mixin.methods.G_isEmptyArr(state.sensorStatus)) {
        commit('setLoading', { ...state.loading, sensorStatus: true });
      }
      GetSensorStatus().then((sensorStatus) => {
        commit('setLoading', { ...state.loading, sensorStatus: false });
        commit('setSensorStatus', sensorStatus);
      }).catch(() => {
        commit('setLoading', { ...state.loading, sensorStatus: false });
      });
    },

    GetRssiIcon({ state }, sensor) {
      const iconRssi = Mixin.methods.G_getRssiIcon(sensor, state.rssiRanges);
      // eslint-disable-next-line
      return require(`@/assets/img/gw/sensor/${iconRssi}`);
    },
  },

  mutations: { /* Mutations are responsible to change the state */
    setSensors(state, sensors) {
      state.sensors = sensors;
    },
    setSensorStatusFilter(state, sensorStatusFilter) {
      state.sensorStatusFilter = sensorStatusFilter;
    },
    setSensorStatus(state, sensorStatus) {
      state.sensorStatus = sensorStatus;
    },

    setRssiRanges(state, rssiRanges) {
      state.rssiRanges = rssiRanges;
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    updateSensor(state, cleanSensor){
      let tempIndex = state.sensors.findIndex( sensor => sensor.sensor_id === cleanSensor.sensor_id );
      state.sensors[tempIndex] = { ...state.sensors[tempIndex], ...cleanSensor };
    },

  },

};
